export function MathToFixed(num, decimal) {
  return parseFloat(Math.round(num, decimal)).toFixed(decimal)
}
/**
 * 乘法
 * @param {*} arg1 
 * @param {*} arg2 
 * @returns 
 */
export function accMul(arg1, arg2) {
  if (!arg1 || !arg2) {
    return 0
  }
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    let arr = s1.split(".")
    if (arr.length === 2) {
      m += arr[1].length
    }
  } catch (e) {
    throw e
  }
  try {
    let arr2 = s2.split(".")
    if (arr2.length === 2) {
      m += arr2[1].length
    }
  } catch (e) {
    throw e
  }
  return Number(s1.replace(".", "") * Number(s2.replace(".", ""))) / Math.pow(10, m)
}

/**
 * 加法
 * @param {*} num1 
 * @param {*} num2 
 * @returns 
 */
export function accAdd(num1, num2) {
  let baseNum, baseNum1, baseNum2;
  let precision; // 精度 
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  return ((num1 * baseNum + num2 * baseNum) / baseNum).toFixed(precision);
}

/**
 * 减法
 * @param {*} num1 
 * @param {*} num2 
 * @returns 
 */
export function accSub(num1, num2) {
  let baseNum, baseNum1, baseNum2;
  let precision; // 精度 
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
}

/**
 * 除法
 * @param {*} num1 
 * @param {*} num2 
 * @returns 
 */
export function accDiv(num1, num2) {
  let baseNum1 = 0
  let baseNum2 = 0;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  let baseNum3 = Number(num1.toString().replace(".", ""));
  let baseNum4 = Number(num2.toString().replace(".", ""));
  return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
}
